import { CompanyTypes, ProductTypes, schemes, zSchema } from "@zeal/common";

export const createCompanyRequestSchema = zSchema.object({
  whiteLabelID: schemes.uuid(),
  business_name: zSchema.string(),
  legalStructure: zSchema.string(),
  business_ein: zSchema.string(),
  business_phone: zSchema.string(),
  business_address: zSchema.string(),
  business_city: zSchema.string(),
  business_state: zSchema.string(),
  business_zip: zSchema.string(),
  isMailingAddressDifferent: zSchema.boolean(),
  mail_address: zSchema.string(),
  mail_city: zSchema.string(),
  mail_state: zSchema.string(),
  mail_zip: zSchema.string(),
  isPhysicalAddressSameAsBusiness: zSchema.boolean(),
  physical_address: zSchema.string(),
  physical_city: zSchema.string(),
  physical_state: zSchema.string(),
  physical_zip: zSchema.string(),
  email: zSchema.string(),
  first_name: zSchema.string(),
  last_name: zSchema.string(),
  job_title: zSchema.string(),
  ownershipPercentage: zSchema.number(),
  ssn: zSchema.string(),
  dob: zSchema.string(),
  address: zSchema.string(),
  address_line2: zSchema.string().optional(),
  city: zSchema.string(),
  state: zSchema.string(),
  zip: zSchema.string(),
  company_type: zSchema.enum(CompanyTypes),
  product_type: zSchema.enum(ProductTypes),
  webhook_correlation_id: zSchema.string().optional(),
  skip_migration: zSchema.string(),
  onboarding_url: zSchema.string(),
});

export type TCreateCompanyRequest = zSchema.infer<
  typeof createCompanyRequestSchema
>;

export interface TCreateCompanyResponse {
  company: { company_id: string };
  clearCookie: boolean;
}
